import axios, { AxiosError } from 'axios';
import { Navigate } from 'react-router-dom';

import { EClient } from '@enums/api.enum';
import { ERoutes } from '@enums/routes.enum';
import i18n from '@locales/i18n';
import { reset, setError } from '@store/auth/authSlice';
import { store } from '@store/store';

type ClientResponse = {
	error?: string;
	message?: string;
	code: number;
};

const apiClient = axios.create({
	baseURL: import.meta.env.VITE_API_ENDPOINT,
	timeout: Number(import.meta.env.VITE_SERVER_REQUEST_TIMEOUT) || 5000,
	headers: {
		Accept: EClient.application,
	},
});

apiClient.interceptors.request.use((config) => {
	const token = store.getState().auth.token;

	if (token) {
		config.headers.Authorization = `${EClient.Bearer} ${token}`;
		config.headers[EClient.authorizationType] = EClient.client;
	}
	return config;
});

const handleApiResponseError = async (error: AxiosError<ClientResponse>) => {
	if (error.response?.status === 401) {
		store.dispatch(reset());
		store.dispatch(setError(error.response?.data?.error));
		return <Navigate to={ERoutes.search} replace={true} />;
	} else {
		store.dispatch(setError(error.response?.data?.error || i18n.t('api.error')));
	}
};

apiClient.interceptors.response.use(
	(response) => response,
	(error) => handleApiResponseError(error),
);

export default apiClient;
